import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9p9pjx33: FaireBrandEntity = {
  token: "b_9p9pjx33",
  type: "brand",
  name: "Simply Earth",
  avatarUrl:
    "https://cdn.faire.com/fastly/875af64f228bd831bf8efd4fdad82d9b752a80624ef12a5671241212994517a9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2de4eb3c4934cb2d5b47c73c67cea294a9ceef8ca29b6f5d596b559d5522f9b9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/875af64f228bd831bf8efd4fdad82d9b752a80624ef12a5671241212994517a9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2de4eb3c4934cb2d5b47c73c67cea294a9ceef8ca29b6f5d596b559d5522f9b9.png",
  location: "Hingham, WI, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 91,
  isTopShop: true,
  isInsider: true,
  description:
    "We created Simply Earth to make using essential oils fun, easy, and affordable for everyone.\n\nBased in Hingham, Wisconsin, Simply Earth is more than just an essential oils company — we’re a community passionate about teaching you how to use oils to create a natural, toxin-free home. Instead of just selling oils, we guide you every step of the way with simple recipes, DIY kits, and expert tips that empower you to make your own safe, healthy products.\n\nWe source our essential oils from the best farms around the world, visiting them personally to ensure the highest quality and to support ethical practices. We believe in fair wages for farmers and work directly with our partners to make sure they're treated well. Beyond creating natural products, we're committed to making a bigger impact — that's why 13% of our profits go toward ending human trafficking. We don't just donate; we visit these organizations, volunteer our time, and build real relationships to help create lasting change.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:08.878Z",
    importedBy: "entity-db-cli",
  },
};
